import { useFlashMessage } from './useFlashMessage'

export default useFlashMessage
